export const environment = {
	production: true,
	//serverUrl: "https://app2.my-cliniq.com",
	//apiUrl: "https://app2.my-cliniq.com/v1",
	serverUrl: "//app2.my-cliniq.com",
	// apiUrl: "//app2.my-cliniq.com/v1",
}
